import React from "react";
import { Link, useLocation } from 'react-router-dom';
import '../App.css';
// import { useState } from "react";
import { useState, useEffect } from "react";
//  import { variables } from '../variables';


 function Navbar() {

  // Get user data from location state
  const location = useLocation();
  const data = location.state; 
//   const role = sessionStorage.getItem("role")   
  const [role, setRole] = useState(null);


  const [showPages, setShowPages] = useState(false);
  const [showLoans, setShowLoans] = useState(false);
  const [showMaternity, setShowMaternity] = useState(false);
  const [showCertReq, setShowCertReq] = useState(false);
  const [showSickness, setshowSickness] = useState(false);
  const [showHMO, setShowHMO] = useState(false);
  const [UpdateEmployee, setUpdateEmployee] = useState(false);
  const [OtherRequest, setOtherRequest] = useState(false);
  const [showHRMenu, setShowHRMenu] = useState(false);
  const [showMaternityTracker, setShowMaternityTracker] = useState(false);
//   const [showTaxForm, setShowTaxForm] = useState(false);
  
  useEffect(() => {
    const employeeId = sessionStorage.getItem("employeeId");
    if (!employeeId) {
        setRole('');
        return;
    }

    fetch('/api/getRole', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ employeeId })
    })
    .then(res => res.json())
    .then(data => {
        setRole(data.role);
        sessionStorage.setItem("role", data.role); // correct sessionStorage too
    })
    .catch(() => setRole(''));
    }, []);

    

  // Loan Management states
  const [showLoanMgmt, setShowLoanMgmt] = useState(false);
  const [showUploadBilling, setShowUploadBilling] = useState(false);

  // Function to toggle the visibility of pages list
  const togglePages = () => {
      setShowPages(!showPages);
  };
  const toggleLoans = () => {
        setShowLoans(!showLoans);
  };
  const toggleMaternity = () => {
        setShowMaternity(!showMaternity);
  };
  const toggleCertReq = () => {
    setShowCertReq(!showCertReq);
  };
  const toggleSickness = () => {
    setshowSickness(!showSickness);
  };
  
  const toggleHMO = () => {
    setShowHMO(!setShowHMO);
  };
  const toggleUpdateEmployee= () => {
    setUpdateEmployee(!UpdateEmployee);
  };
  const toggleOtherRequest = () => {
    setOtherRequest(!OtherRequest);
  };
  const toggleHRMenu = () => { 
    setShowHRMenu(!showHRMenu); 
  };
  const toggleLoanMgmt = () => {
    setShowLoanMgmt(!showLoanMgmt);
  };
//   const toggleTaxForm = () => {
//     setShowTaxForm(!showTaxForm);
//   };
  const toggleUploadBilling = (e) => {
    e.stopPropagation();
    setShowUploadBilling(!showUploadBilling);
  };

        // Wait for DB before rendering
    if (role === null) return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
        <a className="sidebar-brand d-flex align-items-center justify-content-center" href="#">
        <div className="sidebar-brand-text">
            <img src="/img/logo-innodata-white.png" alt="companyLogo" className="logo2" />
        </div>
        </a>
    </ul>
    );
    
     return (
         <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
             {/* Sidebar - Brand */}
             <a className="sidebar-brand d-flex align-items-center justify-content-center" href={role!=="Employee"?"/dashboard":"/submissions"}>
                 <div className="sidebar-brand-text">
                     <img src="/img/logo-innodata-white.png" alt="companyLogo" className="logo2" />
                 </div>
             </a>
             
             {role !== "Employee" && (
        <>
             {/* Divider */}
             <hr className="sidebar-divider my-0" />
             {/* Nav Item - Dashboard */}
             <li className="nav-item">
                <Link className="nav-link" to={{ pathname: "/dashboard"}} state={data}>
                <i className="fas fa-fw fa-tachometer-alt"></i>
                        <span>Dashboard</span>
                  </Link>
             </li>
              {/* Divider */}
              <hr className="sidebar-divider" />
      {/* Conditionally render Employee DB section */}
      {/* {RoleType !== "Employee" && (
        <> */}
          {/* Heading */}
          <div className="sidebar-heading">
            Employee DB
          </div>
          {/* Nav Item - New Hire Upload */}
          <li className="nav-item">
            <Link className="nav-link" to={{ pathname: "/newHireUpload" }} state={data}>
              <i className="fas fa-fw fa-upload"></i>
              <span>New Hire Upload</span>
            </Link>
          </li>
          {/* Nav Item - Reports */}
          <li className="nav-item">
            <Link className="nav-link" to={{ pathname: "/reports" }} state={data}>
              <i className="fas fa-fw fa-chart-bar"></i>
              <span>Report</span>
            </Link>
          </li>
        </>
      )}
      {/* Divider */}
      <hr className="sidebar-divider" />
             {/* Heading */}
             <div className="sidebar-heading">
                 iASSIST 3.0
             </div>
             {/* Nav Item - New Hire Upload */}
             
             {/* { role === 'HRAdmin' &&  
             <li className="nav-item"> 
                 <Link className="nav-link" to={{ pathname: "/newHireUpload"}} state={data}>
                  <i className="fas fa-fw fa-upload"></i>
                  <span>New Hire Upload</span>
                </Link>
             </li>
             } */}
             <li className="nav-item"> 
                 <Link className="nav-link" to={{ pathname: "/submissions"}} state={data}>
                  <i className="fas fa-fw fa-book"></i>
                  <span>Submissions</span>
                </Link>
                 {/* </a> */}
             </li>
             {/* Nav Item - New Hire Upload */}
             <li className="nav-item"> 
                 <label className="mb-0 nav-link" onClick={togglePages}>
                  <i className="fas fa-fw fa-info-circle"></i>
                  <span>iASSIST</span>
                </label>
                {showPages && (
                    <ul className="custom-bullet-list">
                        {/* Add your list of pages here */}  
                        <li onClick={toggleLoans} className="nav-item">
                            <label className="dropdown-text">Government Loan</label>
                            {showLoans && (
                                <ul className="custom-bullet-list">  
                                    <li className="nav-item">
                                        <Link to="/sssloan" className="dropdown-text" state={data}>SSS Loan</Link>
                                    </li> 
                                    <li> 
                                        <Link to="/landbankcard" className="dropdown-text" state={data}>
                                            Pag-Ibig Loan:
                                            <div className="list-padding">Without Loyalty Card Plus</div>
                                        </Link>
                                    </li> 
                                    <li> 
                                        <Link to="/virtualaccount" className="dropdown-text" state={data}>
                                            Pag-Ibig Loan:
                                            <div className="list-padding">With Loyalty Card Plus</div>
                                        </Link>
                                    </li>
                                    <li> 
                                        <Link to="/loanStoppage" className="dropdown-text" state={data}>
                                            Loan Stoppage
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>

                        <li onClick={toggleMaternity}> 
                            <label className="dropdown-text">Maternity</label>
                            {showMaternity && (
                                <ul className="custom-bullet-list sub-menu">
                                    <li>
                                        <Link to="/notification" className="dropdown-text">
                                            Maternity   
                                            <div className="list-padding">Notification</div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/benefit" className="dropdown-text" state={data}>
                                            Maternity Benefit 
                                            <div className="list-padding">Reimbursement</div> 
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li> 

                        <li onClick={toggleCertReq}> 
                            <Link className="dropdown-text" state={data}>Certificate Request</Link>
                            {showCertReq && (
                                <ul className="custom-bullet-list sub-menu">
                                    <li>
                                        <Link to="/SSSrequest" className="dropdown-text" state= { data }> 
                                            SSS   
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/PIrequest" className="dropdown-text"  state= { data }>
                                            PAG-IBIG 
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/PHILHEALTHrequest" className="dropdown-text"  state= { data }>
                                            PHILHEALTH
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>

                        <li onClick={toggleSickness}> 
                            <Link className="dropdown-text" state={data}>SSS Sickness</Link>
                            {showSickness && (
                                <ul className="custom-bullet-list sub-menu">
                                    <li>
                                        <Link to="/SicknessNotification " className="dropdown-text" state={data}>
                                            SSS Sickness  
                                            <div className="list-padding">Notification</div>
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>

                        <li onClick={toggleHMO} style={{display:'none'}}> 
                            <Link className="dropdown-text" state={data}>HMO</Link>
                            {showHMO && (
                                <ul className="custom-bullet-list sub-menu">
                                    <li>
                                        <Link to="/HMO " className="dropdown-text" state={data}>
                                            HMO  
                                            <div className="list-padding">Cocerns</div>
                                        </Link>
                                    </li>
                                </ul>
                            )}

                        </li>

                        <li onClick={toggleUpdateEmployee}>
                            <Link to="/UpdateEmployee" className="dropdown-text" state={data}> 
                                Employee Information 
                                <div className="list-padding">Update</div>
                            </Link>
                        </li>
                        <li onClick={toggleOtherRequest}>
                            <Link to="/OtherRequest" className="dropdown-text" state={data}>Other Request</Link>
                        </li>
                        <li>
                            <Link to="/taxform1902" className="dropdown-text" state={data}>
                                        <div style={{display: 'flex', flexDirection: 'column', lineHeight: 1}}>
                                            <span style={{fontSize: 'inherit'}}>Tin Application</span>
                                            <span style={{fontSize: 'inherit'}}> (BIR 1902) </span>
                                        </div>
                                    </Link>
                        </li>
                    </ul>
                )}
                 {/* </a> */}
                </li> 
                {/* { role === 'HRAdmin' &&  
                    <li className="nav-item"> 
                        <Link className="nav-link" to={{ pathname: "/hriassist"}} state={data}>
                        <i className="fas fa-fw fa-upload"></i>
                        <span>HR iAssist</span>
                        </Link>
                    </li> 
                } */}
                 {role === 'HRAdmin' && (
                <li className="nav-item">
                    <label className="mb-0 nav-link" onClick={toggleHRMenu} style={{ cursor: 'pointer' }}>
                    <i className="fas fa-fw fa-upload"></i>
                    <span>HR iAssist</span>
                    </label>
                    {showHRMenu && (
                    <ul className="custom-bullet-list">
                        <li>
                        <Link to="/hriassist" className="dropdown-text" state={data}>
                            Submissions
                        </Link>
                        </li>
                        <li>
                        <Link to="/maternitytracker" className="dropdown-text" state={data}>
                            Maternity Tracker
                        </Link>
                        </li>
                        {/* <li onClick={toggleTaxForm}>
                            <label className="dropdown-text" style={{ cursor: 'pointer' }}>
                                <div style={{display: 'flex', flexDirection: 'column', lineHeight: 1}}>
                                    <span style={{fontSize: 'inherit'}}>Tin Application</span>
                                    <span style={{fontSize: 'inherit'}}>BIR 1902</span>
                                </div>
                            </label>
                            {showTaxForm && (
                                <ul className="custom-bullet-list sub-menu">
                                    <li>
                                        <Link to="/taxforms/submissions" className="dropdown-text" state={data}>
                                            Tin Application Submissions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/taxforms/archive" className="dropdown-text" state={data}>
                                            Tin Application Archive
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li> */}
                    </ul>
                    )}
                </li>
                )}

                 {/* ── Loan Management Dropdown ── */}
                { role === 'HRAdmin' &&
                    <li className="nav-item">
                        <label className="mb-0 nav-link" onClick={toggleLoanMgmt} style={{ cursor: 'pointer' }}>
                            <i className="fas fa-fw fa-file-invoice-dollar"></i>
                            <span>Loan Management</span>
                        </label>
                        {showLoanMgmt && (
                            <ul className="custom-bullet-list">

                                {/* Loan Tracker */}
                                <li>
                                    <Link to="/loantracker" className="dropdown-text" state={data}>
                                        Loan Tracker
                                    </Link>
                                </li>

                                {/* Upload Billing */}
                                <li onClick={toggleUploadBilling}>
                                    <label className="dropdown-text" style={{ cursor: 'pointer' }}>
                                        Upload Billing
                                    </label>
                                    {showUploadBilling && (
                                        <ul className="custom-bullet-list sub-menu">
                                            <li>
                                                <Link to="/uploadbilling/sss" className="dropdown-text" state={data}>
                                                    SSS
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/uploadbilling/pagibig" className="dropdown-text" state={data}>
                                                    PAG-IBIG
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                {/* Certificate of Loan Remittances */}
                                <li>
                                    <Link to="/certificate/certificateloan" className="dropdown-text" state={data}>
                                        Certificate of Loan
                                        <div className="list-padding">Remittances</div>
                                    </Link>
                                </li>

                                {/* ── Loan Payments (NEW) ── */}
                                <li>
                                    <Link to="/loanpayments/payments" className="dropdown-text" state={data}>
                                    Loan Payments
                                    </Link>
                                </li>

                            </ul>
                        )}
                    </li>
                }


                {/* Nav Item - Reports*/}
                {/* { role === 'HRAdmin' &&  
                <li className="nav-item">
                <Link className="nav-link" to={{ pathname: "/reports"}} state={data} >
                   <i className="fas fa-fw fa-chart-bar"></i>
                   <span>Report</span>
                 </Link>
                </li>
                } */}
            
             {/* Sidebar Toggler (Sidebar) */}
             <br/>
             <div className="text-center d-none d-md-inline">
        </div>
         </ul>
     );
 }
 
 export default Navbar;
 


  